import React from 'react';
import { textEllipsis } from '../../../shared/utils/smartutils';

export default function ColumnsForEventMetrics(t) {
  return [
    {
      title: t('general.name'),
      field: 'responsableName',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.responsableName}>
          {rowData.responsableName}
        </span>
      ),
    },
    {
      title: t('placeholder.responsible.cell-phone'),
      field: 'responsableCellPhone',
    },
    {
      title: t('placeholder.responsible.secondary-cell-phone'),
      field: 'responsableCellPhone1',
    },
    { title: t('placeholder.responsible.phone'), field: 'responsablePhone' },
    {
      title: t('general.email'),
      field: 'responsableEmail',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.responsableEmail}>
          {rowData.responsableEmail}
        </span>
      ),
    },
    {
      title: t('general.responsibilities'),
      field: 'responsabilities',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.responsabilities}>
          {rowData.responsabilities}
        </span>
      ),
    },
    {
      title: t('screens.calendar.confirmationStatus'),
      field: 'confirmationStatus',
    },
    {
      title: t('screens.calendar.confirmationDate'),
      field: 'confirmationDate',
    },
    {
      title: t('screens.calendar.readBy'),
      field: 'readBy',
    },
  ];
}
